// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1TzkX","info":"UpdateTermsInfo_info__2Mmvl"};